import getRouterBasename from '@/lib/router';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import Admin from 'pages/admin';
import AdminCards from 'pages/admin/AdminCards';
import AdminChatDetails from 'pages/admin/AdminChatDetails';
import AdminChatLogs from 'pages/admin/AdminChatLogs';
import AdminComments from 'pages/admin/AdminComments';
import AdminDashboard from 'pages/admin/AdminDashboard';
import AdminDocumentManagement from 'pages/admin/AdminDocumentManagement';
import AdminMessages from 'pages/admin/AdminMessages';
import AdminSiteSync from 'pages/admin/AdminSiteSync';
import AdminTelegramMessageDetails from 'pages/admin/AdminTelegramMessageDetails';
import AdminUserManagement from 'pages/admin/AdminUserManagement';
import AdminWhatsAppMessageDetails from 'pages/admin/AdminWhatsAppMessageDetails';
import AuthCallback from 'pages/AuthCallback';
import Element from 'pages/Element';
import Env from 'pages/Env';
import Home from 'pages/Home';
import Login from 'pages/Login';
import NotFound from 'pages/NotFound';
import Settings from 'pages/Settings';
import SharedThread from 'pages/SharedThread';
import Thread from 'pages/Thread';

export const router: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter(
    [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/env',
        element: <Env />
      },
      {
        path: '/thread/:id?',
        element: <Thread />
      },
      {
        path: '/share/:token',
        element: <SharedThread />
      },
      {
        path: '/element/:id',
        element: <Element />
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/login/callback',
        element: <AuthCallback />
      },
      {
        path: '/settings',
        element: <Settings />
      },
      {
        path: '/admin',
        element: <Admin />,
        children: [
          {
            index: true,
            element: <AdminDashboard />
          },
          {
            path: 'chat-logs',
            element: <AdminChatLogs />
          },
          {
            path: 'chat-logs/:threadId',
            element: <AdminChatDetails />
          },
          {
            path: 'documents',
            element: <AdminDocumentManagement />
          },
          {
            path: 'site-sync',
            element: <AdminSiteSync />
          },
          {
            path: 'comments',
            element: <AdminComments />
          },
          {
            path: 'admins',
            element: <AdminUserManagement />
          },
          {
            path: 'messages',
            element: <AdminMessages />
          },
          {
            path: 'cards',
            element: <AdminCards />
          },
          {
            path: 'telegram-messages',
            element: <Navigate to="/admin/chat-logs?tab=telegram" replace />
          },
          {
            path: 'telegram-messages/:messageId',
            element: <AdminTelegramMessageDetails />
          },
          {
            path: 'whatsapp-messages',
            element: <Navigate to="/admin/chat-logs?tab=whatsapp" replace />
          },
          {
            path: 'whatsapp-messages/:messageId',
            element: <AdminWhatsAppMessageDetails />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ],
    { basename: getRouterBasename() }
  );
